module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer "
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    attrs: {
      "href": "https://uniquery.jp/",
      "target": "_blank"
    }
  }, [_vm._v("\n      ふりすぽ\n    ")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://uniquery.jp/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Copyright")]), _vm._v(" (C) Uniquery Inc. All Rights Reserved.\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fbc5802"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Footer.vue
// module id = 447
// module chunks = 1